import React from "react";
import TicketForm from "../../components/TicketForm";

export default function ChamadoDevolucao() {
  return (
    <TicketForm
      tipo="devolucao"
      title="Solicitar devolução"
      subtitle="Confirme com sua equipe antes de prosseguir."
      alert={{
        tipo: "warning",
        texto:
          "A devolução encerra a locação do equipamento selecionado. Esta ação será revisada pela equipe Locar.",
      }}
      motivos={[
        "Fim do contrato",
        "Não preciso mais",
        "Substituição por outro modelo",
      ]}
    />
  );
}
